import React from 'react';
import { Link } from 'react-router-dom';

//import translation function for language translation
import { useTranslation } from 'react-i18next';

const InstallationsNav = ({ setDownloadExcel }) => {
  const { t } = useTranslation(); //for translation

  /* function to click download xls*/
  const handleDownloadClick = () => {
    setDownloadExcel(true);

    setTimeout(() => setDownloadExcel(false), 500);
  };

  return (
    <>
      <nav aria-label="breadcrumb">
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="dashboard.html" className="text-secondary">
              {t('Funbrain')}
            </Link>
          </li>
          <li className="breadcrumb-item text-gray-600" aria-current="page">
            {t('Installations')}
          </li>
        </ul>
      </nav>
      <div className="filter-container d-flex flex-wrap align-items-center gap-2 pb-3">
        <Link
          to="#columnCollapse"
          className="btn btn-primary mw-unset p-2"
          data-bs-toggle="collapse"
          role="button"
          aria-expanded="false"
          aria-controls="columnCollapse"
        >
          <span className="d-block material-symbols-outlined icon-fill">
            visibility
          </span>
        </Link>
        <Link
          to="#"
          onClick={handleDownloadClick}
          className="btn btn-primary mw-unset p-2"
        >
          <span className="d-block material-symbols-outlined">download</span>
        </Link>

        <div className="search-container position-relative d-none d-md-block">
          <form action="">
            <input
              type="search"
              placeholder={t('Search here')}
              className="form-control bg-transparent py-2 border-0"
            />
            <button
              type="submit"
              className="bg-transparent text-dark p-0 border-0 position-absolute top-50 translate-middle-y"
            >
              <span className="d-block material-symbols-outlined">search</span>
            </button>
          </form>
        </div>
        <Link
          to="#filterCollapse"
          className="btn btn-primary mw-unset p-2 ms-auto"
          data-bs-toggle="collapse"
          role="button"
          aria-expanded="false"
          aria-controls="filterCollapse"
        >
          <span className="d-block material-symbols-outlined">filter_alt</span>
        </Link>
        <Link
          to="#saveReservationPopup"
          data-bs-toggle="offcanvas"
          role="button"
          aria-controls="saveReservationPopup"
          className="btn btn-primary mw-unset p-2"
        >
          <span className="d-block material-symbols-outlined">add</span>
        </Link>
        <div className="dropdown">
          <button
            className="btn btn-primary dropdown-toggle mw-unset"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {t('Actions')}
          </button>
          <ul className="dropdown-menu border-0 shadow-lg">
            <li>
              <Link className="dropdown-item" to="#">
                {t('Add Label')}
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                {t('Download in Xls')}
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                {t('Upload xls function')}
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                {t('Change Status')}
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                {t('Send Notification')}
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                {t('Delete selected')}
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                {t('Upload Holiday Calendar')}
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                {t('Duplicate selected')}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default InstallationsNav;
